import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMuayeneler } from '../services/api';

const bugun = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};
const trTarih = (s) => s ? new Date(s).toLocaleDateString('tr-TR') : '—';

const ONBELLEK_ANAHTAR = 'muayeneler_filtre';

export default function Muayeneler() {
  const navigate = useNavigate();
  const onbellek = (() => {
    try { return JSON.parse(sessionStorage.getItem(ONBELLEK_ANAHTAR) || 'null'); } catch { return null; }
  })();

  const [bas, setBas] = useState(onbellek?.bas || bugun());
  const [bit, setBit] = useState(onbellek?.bit || bugun());
  const [liste, setListe] = useState(onbellek?.liste || []);
  const [yukleniyor, setYukleniyor] = useState(!onbellek);

  const yukle = useCallback((b, s) => {
    setYukleniyor(true);
    getMuayeneler(b, s)
      .then(res => {
        setListe(res.data);
        sessionStorage.setItem(ONBELLEK_ANAHTAR, JSON.stringify({ bas: b, bit: s, liste: res.data }));
      })
      .catch(() => setListe([]))
      .finally(() => setYukleniyor(false));
  }, []);

  useEffect(() => {
    if (!onbellek) yukle(bas, bit);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const listele = (e) => { e.preventDefault(); yukle(bas, bit); };

  return (
    <div>
      <h1 className="sayfa-baslik">Muayeneler</h1>
      <p className="sayfa-alt">Tarih aralığı seçin, muayene listesini görüntüleyin.</p>

      <form onSubmit={listele} style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap', marginBottom: 18 }}>
        <div className="form-row">
          <div className="form-label">Başlangıç</div>
          <input type="date" className="input" value={bas} onChange={e => setBas(e.target.value)} />
        </div>
        <div className="form-row">
          <div className="form-label">Bitiş</div>
          <input type="date" className="input" value={bit} onChange={e => setBit(e.target.value)} />
        </div>
        <button className="btn" type="submit">Listele</button>
      </form>

      {!yukleniyor && liste.length > 0 && (
        <div style={{ marginBottom: 12 }}>
          <span className="bilgi-rozet">📋 {liste.length} muayene</span>
        </div>
      )}

      <div className="kart" style={{ overflow: 'hidden' }}>
        {yukleniyor ? (
          <div className="bos-durum">Yükleniyor…</div>
        ) : liste.length === 0 ? (
          <div className="bos-durum">Bu tarih aralığında muayene bulunamadı.</div>
        ) : (
          <table className="tablo">
            <thead>
              <tr>
                <th style={{ width: 110 }}>Tarih</th>
                <th style={{ width: 70 }}>Saat</th>
                <th>Hasta</th>
                <th style={{ width: 160 }}>Doktor</th>
                <th style={{ width: 90 }}>Tür</th>
              </tr>
            </thead>
            <tbody>
              {liste.map(m => (
                <tr key={m.id} onClick={() => navigate(`/muayene/${m.id}`)} style={{ cursor: 'pointer' }}>
                  <td style={{ fontWeight: 600 }}>{trTarih(m.tar)}</td>
                  <td>{m.saat}</td>
                  <td>
                    <span style={{ color: 'var(--mor)', fontWeight: 600 }}>{m.adSoy || '—'}</span>
                  </td>
                  <td style={{ color: 'var(--metin-soluk)' }}>{m.doktor || '—'}</td>
                  <td>
                    {m.kontrol
                      ? <span className="rozet rozet-e">Kontrol</span>
                      : <span className="rozet" style={{ background: '#e7f0ff', color: '#2563c9' }}>Muayene</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
